import createReducer from './baseReducer';

export default createReducer('postcodes', 'postcode');
